import { Typography } from '@mui/material'
import React from 'react'

const SelectCurriculum = () => {
  return (
    <div className='flex items-center justify-center h-full'>
      <Typography className='text-muted-foregroud opacity-25'>
        Select Curriculum
      </Typography>
    </div>
  )
}

export default SelectCurriculum